import React, { useRef } from "react";
import { motion, useScroll, useSpring } from "framer-motion";

export default function Timeline({ items = [] }) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 70%", "end 60%"] });
  const height = useSpring(scrollYProgress, { stiffness: 80, damping: 20 });

  return (
    <div ref={ref} className="relative mt-14">
      {/* center line */}
      <div className="absolute left-6 md:left-1/2 top-0 bottom-0 w-px bg-primary/10 -translate-x-1/2" />
      <motion.div
        style={{ scaleY: height }}
        className="absolute left-6 md:left-1/2 top-0 bottom-0 w-[2px] bg-secondary -translate-x-1/2 origin-top"
      />
      <div className="space-y-10 md:space-y-2">
        {items.map((item, i) => {
          const left = i % 2 === 0;
          return (
            <div key={i} className="relative md:grid md:grid-cols-2 md:gap-12 items-center">
              {/* node */}
              <span className="absolute left-6 md:left-1/2 -translate-x-1/2 w-4 h-4 rounded-full bg-secondary ring-4 ring-background z-10 mt-1 md:mt-0" />
              <motion.div
                initial={{ opacity: 0, x: left ? -30 : 30, y: 20 }}
                whileInView={{ opacity: 1, x: 0, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
                className={`pl-16 md:pl-0 py-6 ${left ? "md:pr-16 md:text-right" : "md:col-start-2 md:pl-16"}`}
              >
                <span className="inline-block font-display text-5xl md:text-6xl font-semibold text-secondary leading-none">{item.year}</span>
                <h3 className="font-display text-2xl font-semibold text-primary mt-2">{item.title}</h3>
                <p className="text-foreground/70 mt-1 leading-relaxed max-w-sm md:inline-block">{item.body}</p>
              </motion.div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
